import { render, staticRenderFns } from "./fee.vue?vue&type=template&id=317e7338"
import script from "./fee.vue?vue&type=script&lang=ts"
export * from "./fee.vue?vue&type=script&lang=ts"
import style0 from "./fee.vue?vue&type=style&index=0&id=317e7338&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports